

export const getMetricColumnWidth = (metricName: string, hasIcon?: boolean) => {
  return Math.max(metricName.length * 7 + 10.5, 50) + 20 + (hasIcon ? 15 : 0);
};
